import { render, staticRenderFns } from "./rate-limiting.vue?vue&type=template&id=42c6c814&"
import script from "./rate-limiting.vue?vue&type=script&lang=js&"
export * from "./rate-limiting.vue?vue&type=script&lang=js&"
import style0 from "./rate-limiting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports